import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { getBranches } from "../Services/Api";

const STORAGE_KEY = "selectedBranchId";

const BranchContext = createContext(null);

export function BranchProvider({ children }) {
  const [branches, setBranches] = useState([]);

  const roleId = localStorage.getItem("roleId");
  const assignedBranchId = localStorage.getItem("branchId");
  const isBranchManager = roleId === "3";
  const isAdmin = roleId === "1" || roleId === "2";

  const [selectedBranchId, setSelectedBranchIdState] = useState(() => {
    if (isBranchManager && assignedBranchId) return Number(assignedBranchId);
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved ? Number(saved) : "";
  });

  useEffect(() => {
    if (isBranchManager && assignedBranchId) {
      setSelectedBranchIdState(Number(assignedBranchId));
    }
  }, [isBranchManager, assignedBranchId]);

  const setSelectedBranchId = useCallback((id) => {
    if (isBranchManager) return;
    setSelectedBranchIdState(id);
    if (id) {
      localStorage.setItem(STORAGE_KEY, id);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  }, [isBranchManager]);

  const clearBranch = useCallback(() => {
    setSelectedBranchIdState("");
    localStorage.removeItem(STORAGE_KEY);
  }, []);

  const refreshBranches = useCallback(() => {
    if (!isAdmin) return;
    getBranches()
      .then((res) => {
        const list = res.data?.data?.data || res.data?.data || [];
        setBranches(list);
      })
      .catch(() => {});
  }, [isAdmin]);

  return (
    <BranchContext.Provider value={{
      branches,
      selectedBranchId,
      setSelectedBranchId,
      clearBranch,
      refreshBranches,
      isBranchManager,
    }}>
      {children}
    </BranchContext.Provider>
  );
}

export function useBranch() {
  return useContext(BranchContext);
}
